// tiny_face_detector options
let inputSize = 512;
let scoreThreshold = 0.5;
/**
 * face-api 需要动态引入，因为其初始化代码中会
 * Object.defineProperty(some function, 'name',  {
 *    value: xxx
 * })
 *
 * 在 seafile Windows 客户端会报错，直接白屏
 */
export function getFaceDetectorOptions() {
  const TinyFaceDetectorOptions =
    require("face-api.js").TinyFaceDetectorOptions;

  return new TinyFaceDetectorOptions({ inputSize, scoreThreshold });
}

export function getCurrentFaceDetectionNet() {
  return require("face-api.js").nets.tinyFaceDetector;
}

export function isFaceDetectionModelLoaded() {
  return !!getCurrentFaceDetectionNet().params;
}
